module.exports = __webpack_public_path__ + "img/summary.0513fe08.png";